// Modify ToggleSwitch.js
import React, { useState } from "react";
import "../styles/ToggleSwitch.css";

export const ToggleSwitch = ({ label, is_active, onToggle }) => {
  const [isActive, setIsActive] = useState(is_active);

  const toggleSwitch = () => {
    setIsActive(!isActive);
    onToggle(!isActive); // Notify the parent component of the toggle event
  };

  return (
    <div className={`container ${isActive ? 'active' : ''}`}>

      <div className="toggle-switch" onClick={toggleSwitch}>
        <div className={`slider ${isActive ? 'slider-active' : ''}`}></div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
